import { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
const ModalContext = createContext();
export const ModalContextProvider = ({ children }) => {
  const [sitesettings, setSitesettings] = useState({});
  const [profiledata, setProfiledata] = useState({});
  const [commonloader, setCommonloader] = useState(false);
  const [theme,setTheme] = useState(false)
  const [isExport, setIsExport] = useState(false)


  const contextValue = useMemo(() => ({
    sitesettings,
    setSitesettings,
    profiledata,
    setProfiledata,
    commonloader,
    setCommonloader,
    theme,
    setTheme,
    isExport, setIsExport
  }), [sitesettings, profiledata, commonloader, theme,isExport]);
  return (
    <ModalContext.Provider value={contextValue}>
      {children}
    </ModalContext.Provider>
  );
};
ModalContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export const useModalContext = () => useContext(ModalContext); 